/**
 * search-toggle.js
 * Handles toggling off-screen navigation
 */
export default class SearchToggle {
    constructor() {
        this.settings = {
            searchToggle: document.getElementById('search-toggle'),
            searchOverlays: document.querySelectorAll('[data-search-overlay]'),
            body: document.body,
            activeClass: 'js-search-open',
            overlayClass: 'js-overlay-active'
        };
    }

    init() {
        if (this.settings.searchToggle && this.settings.searchOverlays.length) {
            this.bindUIActions();
        } else {
            console.warn('Search elements not found:', {
                searchToggle: !!this.settings.searchToggle,
                searchOverlays: this.settings.searchOverlays.length
            });
        }
    }

    bindUIActions() {
        const { searchToggle } = this.settings;

        window.addEventListener('resize', () => {
            if (window.innerWidth < 899) this.toggleClass('remove');
        });

        searchToggle.addEventListener('click', () => {
            this.toggleClass();
        });
    }

    toggleClass(status) {
        const { body, searchOverlays, searchToggle, activeClass, overlayClass } = this.settings;
        const isActive = body.classList.contains(activeClass);

        if (isActive || status === 'remove') {
            body.classList.remove(activeClass);
            searchOverlays.forEach(overlay => overlay.classList.remove(overlayClass));
            searchToggle.setAttribute('aria-expanded', 'false');
            searchToggle.setAttribute('aria-label', 'Open search');
            searchToggle.focus();

            searchOverlays.forEach(overlay => {
                const searchField = overlay.querySelector('#search-input, .search-field');
                if (searchField) {
                    searchField.value = '';
                }
            });
        } else {
            body.classList.add(activeClass);
            searchOverlays.forEach(overlay => overlay.classList.add(overlayClass));
            searchToggle.setAttribute('aria-expanded', 'true');
            searchToggle.setAttribute('aria-label', 'Close search');
            this.focusSearchField();
        }
    }

    focusSearchField(retries = 4) {
        const { searchOverlays } = this.settings;
        const searchField = searchOverlays[0] && searchOverlays[0].querySelector('#search-input, .search-field');

        if (!searchField) {
            return;
        }

        const fieldStyles = window.getComputedStyle(searchField);
        const isFocusable =
            fieldStyles.visibility !== 'hidden' &&
            fieldStyles.display !== 'none' &&
            searchField.offsetParent !== null;

        if (isFocusable) {
            searchField.focus({ preventScroll: true });
            return;
        }

        if (retries > 0) {
            window.setTimeout(() => this.focusSearchField(retries - 1), 50);
        }
    }
}
